import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3755f91e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "page-title" }, "マイページ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "page-section-title" }, "ご利用中のチェックシート", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row q-gutter-xs no-wrap items-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("ゴミ箱アイコンをクリックするとチェックシートを削除できます")
const _hoisted_6 = { class: "col-12 content" }
const _hoisted_7 = { class: "sp-table-btnWrap" }
const _hoisted_8 = {
  class: "full-width text-center",
  style: {"padding":"20px 12px","font-size":"16px","font-weight":"bold"}
}

import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAsyncTask } from 'vue-concurrency'
import { QTableProps } from 'quasar'
import dayjs from 'dayjs'
import api from '@/api'
import { Book } from '@/models'
import { useErrorStore, useUserStore } from '@/stores'
import { swalConfirm, swalToast, swalError } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()
const errorStore = useErrorStore()

const books = ref<Book[]>([])
const bookTemplateList = ref([])
const selectTemplate = ref('')

const columns: QTableProps['columns'] = [
  {
    name: 'insDt',
    label: '作成日時',
    field: row => dayjs(row.insDt).format('YYYY-MM-DD HH:mm'),
    align: 'center',
    headerClasses: 'bg-grey-1',
    headerStyle: 'font-weight: bold; text-align: center',
  },
  {
    name: 'sheetStartDt',
    label: '回答開始',
    field: row => dayjs(row.sheetStartDt).format('YYYY-MM-DD HH:mm'),
    align: 'center',
    headerClasses: 'bg-grey-1',
    headerStyle: 'font-weight: bold; text-align: center',
  },
  {
    name: 'sheetTermDt',
    label: '回答期限',
    field: row => dayjs(row.sheetTermDt).format('YYYY-MM-DD HH:mm'),
    align: 'center',
    headerClasses: 'bg-grey-1',
    headerStyle: 'font-weight: bold; text-align: center',
  },
  {
    name: 'unit',
    label: '回答人数',
    field: row => `${row.sheetUnit} / ${row.sheetLimitUnit} 人`,
    align: 'center',
    headerClasses: 'bg-grey-1',
    headerStyle: 'font-weight: bold; text-align: center',
  },
  {
    name: 'bookName',
    label: 'チェックシート名',
    field: 'bookName',
    align: 'left',
    style: 'white-space: normal; word-break: break-word;',
    headerClasses: 'bg-grey-1',
    headerStyle: 'font-weight: bold; text-align: center',
  },
  {
    name: 'actions',
    label: '操作',
    field: '',
    align: 'center',
    headerClasses: 'bg-grey-1',
    headerStyle: 'font-weight: bold; text-align: center',
  },
]

const pagination = ref<QTableProps['pagination']>({
  sortBy: 'sheetStartDt',
  descending: true,
  page: 1,
  rowsPerPage: 10,
  rowsNumber: 0,
})

function getPaginationLabel(first: number, end: number, total: number) {
  return `${first}～${end}件 (全${total}件)`
}

const getListBooktask = useAsyncTask(async (_, data: { pagination: QTableProps['pagination'] }) => {
  return api.mypage
    .listBook({ pagination: data.pagination })
    .then(data => {
      books.value = data.resultList
      pagination.value = { ...pagination.value, ...data.pagination }
      return data
    })
    .catch(err => {
      userStore.clearHash()
      errorStore?.go(err)
    })
}).drop()

const getMyPageDataTask = useAsyncTask(async (_signal, data: { cd: string | null }) => {
  return api.mypage.getData({ cd: data.cd }).then(res => {
    bookTemplateList.value = res
    // テンプレートが一つしかない場合はそのテンプレートを使用
    if (bookTemplateList.value.length <= 1) {
      selectTemplate.value = bookTemplateList.value[0]
    }
  })
})

getMyPageDataTask.perform({ cd: userStore.hash })
getListBooktask.perform({ pagination: pagination.value })

const onRequest: QTableProps['onRequest'] = function (requestProp) {
  getListBooktask.perform({ pagination: requestProp.pagination })
}

function createBook() {
  if (selectTemplate.value !== '') {
    swalConfirm.fire({ text: 'チェックシートを追加してよろしいですか？' }).then(result => {
      if (result.isConfirmed) {
        const bookadd = {
          userHash: userStore.hash,
          userTemplate: selectTemplate.value,
        }
        api.mypage.createBook(bookadd).then(data => {
          router.push({ path: 'book', query: { cd: data.bookHash } })
        })
      }
    })
  } else {
    swalError.fire({ text: 'テンプレートが未選択です。\nテンプレートを選択して、新規作成をしてください。' })
  }
}

function deleteBook(cd: string) {
  swalConfirm.fire({ text: 'チェックシートを削除してよろしいですか？' }).then(result => {
    if (result.isConfirmed) {
      api.mypage.deleteBook({ cd }).then(() => {
        swalToast.fire({ text: '削除しました' })
        getListBooktask.perform({ pagination: { ...pagination.value, page: 1 } })
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", null, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["flex", _ctx.$q.screen.lt.sm ? 'justify-center' : 'justify-end'])
        }, [
          (bookTemplateList.value.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_q_select, {
                  style: {"min-width":"400px"},
                  outlined: "",
                  dense: "",
                  label: "テンプレート",
                  modelValue: selectTemplate.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectTemplate).value = $event)),
                  options: bookTemplateList.value,
                  class: "q-mr-sm"
                }, null, 8, ["modelValue", "options"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_q_btn, {
            style: _normalizeStyle([_ctx.$q.screen.lt.sm ? 'max-width: 357px; width: 100%' : '', {"margin-bottom":"33px","height":"40px"}]),
            unelevated: "",
            color: "primary",
            label: "チェックシートの新規作成",
            onClick: createBook
          }, null, 8, ["style"])
        ], 2)
      ]),
      _createVNode(_component_q_table, {
        flat: "",
        bordered: "",
        square: "",
        dense: "",
        rows: books.value,
        columns: columns,
        pagination: pagination.value,
        "onUpdate:pagination": _cache[1] || (_cache[1] = ($event: any) => ((pagination).value = $event)),
        loading: _unref(getListBooktask).isRunning,
        "pagination-label": getPaginationLabel,
        "rows-per-page-options": [0],
        "hide-bottom": _unref(getListBooktask).isRunning,
        onRequest: onRequest,
        grid: _ctx.$q.screen.lt.sm,
        "no-data-label": "ご利用中のチェックシートはありません。チェックシートを新規作成してください。"
      }, {
        header: _withCtx((props) => [
          _createVNode(_component_q_tr, { props: props }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                return (_openBlock(), _createBlock(_component_q_th, {
                  key: col.name,
                  props: props
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(col.label), 1)
                  ]),
                  _: 2
                }, 1032, ["props"]))
              }), 128))
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        "body-cell-actions": _withCtx((props) => [
          _createVNode(_component_q_td, { props: props }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_q_btn, {
                  unelevated: "",
                  color: "primary",
                  label: "詳細",
                  to: { path: 'book', query: { cd: props.row.bookHash } }
                }, null, 8, ["to"]),
                _createVNode(_component_q_btn, {
                  unelevated: "",
                  color: "secondary",
                  label: "結果",
                  to: { path: 'result', query: { cd: props.row.bookHash } }
                }, null, 8, ["to"]),
                _createVNode(_component_q_icon, {
                  class: "cursor-pointer",
                  name: "fas fa-trash",
                  color: "grey-7",
                  size: "1.6em",
                  style: {"margin-left":"13px"},
                  onClick: ($event: any) => (deleteBook(props.row.bookHash))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 2
          }, 1032, ["props"])
        ]),
        item: _withCtx((props) => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_q_card, { style: {"border":"2px solid #6cb4e4","box-shadow":"none","border-radius":"8px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, {
                  class: "q-pa-sm",
                  style: {"background-color":"#e3eff9"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("strong", null, _toDisplayString(props.row.bookName), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_card_section, { class: "q-pa-sm" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, "作成日時： " + _toDisplayString(props.row.insDt), 1),
                    _createElementVNode("div", null, "回答日時： " + _toDisplayString(props.row.sheetStartDt), 1),
                    _createElementVNode("div", null, "回答期限： " + _toDisplayString(props.row.sheetTermHour), 1),
                    _createElementVNode("div", null, "回答人数： " + _toDisplayString(props.row.sheetUnit) + " / " + _toDisplayString(props.row.sheetLimitUnit) + " 人", 1)
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_q_btn, {
                    unelevated: "",
                    dense: "",
                    color: "primary",
                    label: "詳細",
                    to: { path: 'book', query: { cd: props.row.bookHash } }
                  }, null, 8, ["to"]),
                  _createVNode(_component_q_btn, {
                    unelevated: "",
                    dense: "",
                    color: "secondary",
                    label: "結果",
                    to: { path: 'result', query: { cd: props.row.bookHash } }
                  }, null, 8, ["to"]),
                  _createVNode(_component_q_icon, {
                    class: "q-mr-xs",
                    name: "fas fa-trash",
                    color: "grey-7",
                    size: "1.4em",
                    onClick: ($event: any) => (deleteBook(props.row.bookHash))
                  }, null, 8, ["onClick"])
                ])
              ]),
              _: 2
            }, 1024)
          ])
        ]),
        loading: _withCtx(() => [
          _createVNode(_component_q_inner_loading, {
            showing: "",
            color: "gray"
          })
        ]),
        "no-data": _withCtx(({ message }) => [
          _createElementVNode("div", _hoisted_8, _toDisplayString(message), 1)
        ]),
        _: 1
      }, 8, ["rows", "pagination", "loading", "hide-bottom", "grid"])
    ])
  ]))
}
}

})